import React from "react";
import "../styles/BelpimpalgaonBhushan.css";

const BelpimpalgaonBhushan = () => {
  return (
    <div className="bhushan-page">

      <h1 className="main-title">
        🌟 बेलपिंपळगाव भूषण 🌟
      </h1>
      <p className="subtitle">
        विविध क्षेत्रांत उल्लेखनीय कार्य करून गावाचा गौरव वाढवणारी मान्यवर व्यक्तिमत्वे
      </p>

      {/* राजकीय */}
      <section className="bhushan-section">
        <h2>🏛️ राजकीय क्षेत्र</h2>
        <ul>
          <li>मा. आ. भाऊराव गोविंद चौगुले – नेवासा, श्रीरामपूर मतदार संघ </li>
          <li>श्री दिगंबर सर्जेराव शिंदे –(माजी सभापती व चेअरमन १९५२–१९५७) </li>
          <li>श्री वसंतराव भाऊराव रोटे – कृषी उत्पन्न बाजार समिती </li>
          <li>श्री रविंद्र सखाराम शेरकर - सदस्य पंचायत समिती</li>
          <li>सौ. कांताबाई दत्तात्रय कांगुणे – सदस्य पंचायत समिती</li>
          <li>श्री सखाराम गंगाधर कागुणे – संचालक, अशोक कारखाना</li>
          <li>श्री कल्याणराव प्रतापराव शिंदे – चेअरमन, शिक्षक बँक</li>
          <li>श्री अमोल बाबासाहेब कोकणे – संचालक, अशोक कारखाना</li>
          <li>श्री वसत वामनराव शेरकर – संचालक, बाभळेश्वर दूध संघ</li>
          <li>श्री कार्लस कचरू साठे – उपजिल्हा अध्यक्ष, काँग्रेस कमिटी</li>
          <li>श्री सचिन नाना चौगुले – काँग्रेस शहर अध्यक्ष, शिर्डी नगरसेवक</li>
          <li> राजेंद्र दशरथ साठे – माजी तालुका अध्यक्ष, R.P.I</li>
          <li>श्री बाळासाहेब मधुकर शिंदे – माजी शिवसेना तालुकाध्यक्ष</li>
        </ul>
      </section>

      {/* सरकारी सेवक */}
      <section className="bhushan-section">
  <h2>🛡️ सरकारी सेवक</h2>
  <ul>
    <li>श्री आनंद शिवाजी कागुणे – A.P.I</li>
    <li>श्री विजय किसन साठे</li>
    <li>श्री चेतन मनोज पवार</li>
    <li>श्री राहुल शिवाजी शेरकर – S.T.I</li>
    <li>श्री शशिकांत भास्कर गटकळ – रासायनिक विश्लेषक अधिकारी</li>
    <li>श्री योगेश पुंजाराम मेहेत्रे</li>
    <li>श्री सोमनाथ मधुकर मुंडले – पो. कॉ.</li>
    <li>श्री रविष्ट विजय साठे</li>

    <li>श्री राहुल बाळासाहेब कचरे</li>
    <li>श्री पंकज विजयपूरी गोरखी</li>
    <li>श्री बाळासाहेब आण्णासाहेव कणगरे</li>
    <li>श्री नितीन जगनाय शिरसाठ</li>
    <li>श्रीमती अजनी बाब</li>
    <li>श्री दीपक रावसाहेब खाडे – सैन्य दल</li>
    <li>श्री दीपक चौपट आहे</li>
    <li>श्री आरमेश विजय शिंदे</li>
    <li>श्री राहुल परसराम गटकळ</li>
    <li>श्री प्रदीप बसत तागड</li>
    <li>श्री कैलास बसत तागड</li>
    <li>श्री दिलीप राजसाहेब तरस</li>
    <li>श्री आकाश विजय धिरडे</li>
    <li>श्री रामेश्वर बाळासाहेब शिटे</li>
    <li>श्री जानेश्वर बाळासाहेब सा</li>
    <li>श्री अरुण गोकुलदास – माजी सैनिक</li>
    <li>श्री संभाजी भाऊराव आमडे</li>
    <li>श्री संजय गोपीनाथ कदम</li>
    <li>श्री आण्णासाहेब आऊसाहेब गायकवाड</li>

    <li>श्री कल्याणराव पतापराव हिंदे – मुख्याध्यापक</li>
    <li>श्री बाबासाहेब दामोधर शिदे – शिक्षक</li>
    <li>श्री अर्जुन सीताराम पुंड – शिक्षक</li>
    <li>श्री विद्युल पुजाहारी कागुणे – शिक्षक</li>
    <li>श्री राजेश अशोकराव शिंदे – शिक्षक</li>
    <li>सौ. कौशल्या विबक गायकवाड – मुख्याध्यापिका</li>
    <li>श्री रुपेश श्रीकृष्ण शिंदे – शिक्षक</li>
    <li>श्री विजय लक्ष्मण आधाडे – शिक्षक</li>

    <li>श्री बिक नाना गायकवाड – सेवानिवृत्त जि.प. कक्ष अधिकारी</li>
    <li>श्री गणपत रामचट गटकळ – सेवानिवृत्त मुख्याध्यापक</li>
    <li>श्री पल्हाद गेनुजी खरात – सेवानिवृत्त मुख्याध्यापक</li>
    <li>श्री बाळासाहेब दत्तात्रय शिटे – सेवानिवृत्त मुख्याध्यापक</li>
    <li>श्री विलास प्रताप शिंदे – सेवानिवृत्त मुख्याध्यापक</li>

    <li>श्री दिगंबर विश्वनाथ शिंदे</li>
    <li>श्री कार्लस कचरू साठे</li>
    <li>श्री राहुल कार्लस साठे – तलाठी</li>
    <li>श्री विजय सूर्यभान मेहेत्रे – ग्रामविकास अधिकारी</li>
  </ul>
</section>


      {/* शैक्षणिक */}
      <section className="bhushan-section">
        <h2>🎓 शिक्षण क्षेत्र</h2>
        <ul>
          <li>श्री कल्याणराव प्रतापराव शिंदे – मुख्याध्यापक</li>
          <li>श्री बाबासाहेब दामोधर शिंदे – शिक्षक</li>
          <li>श्री अर्जुन सीताराम पुंड – शिक्षक</li>
          <li>श्री विद्युल पुजाहारी कागुणे – शिक्षक</li>
          <li>श्री राजेश अशोकराव शिंदे – शिक्षक</li>
          <li>सी. कौशल्या विबक गायकवाड – मुख्याध्यापिका</li>
          <li>श्री गणपत रामचट गटकळ – सेवानिवृत्त मुख्याध्यापक</li>
          <li>श्री पल्हाद गेनुजी खरात – सेवानिवृत्त मुख्याध्यापक</li>
          <li>श्री बाळासाहेब दत्तात्रय शिटे – सेवानिवृत्त मुख्याध्यापक</li>
          <li>श्री रामचट शंकर मेहेत्रे – सेवानिवृत्त मुख्याध्यापक</li>
        </ul>
      </section>

      {/* शैक्षणिक पदवी */}
      <section className="bhushan-section">
        <h2>📘 शैक्षणिक पदवी</h2>
        <ul>
          <li>श्री अमिन सय्यदभाई सय्यद</li>
          <li>श्री किशोर जगन्नाथ गटकळ</li>
          <li>श्री गोकुळ चांगदेव पुंड</li>
        </ul>
      </section>

      {/* युवा उद्योजक */}
      <section className="bhushan-section">
        <h2>🚀 युवा उद्योजक</h2>
        <ul>
          <li>श्री रविंद्र सखाराम शेरकर – Reflection Media</li>
          <li>श्री संतोष भारत चौगुले – साईनाथ ट्रेडर्स, साई प्रोव्हिजन स्टोअर</li>
        </ul>
      </section>

      {/* उत्कृष्ट शेतकरी */}
      <section className="bhushan-section">
        <h2>🌾 उत्कृष्ट शेतकरी</h2>
        <ul>
          <li>श्री चंद्रशेखर गणपत गटकळ – पेरू</li>
          <li>श्री संजय किसन साठे – पेरू</li>
          <li>श्री दत्तात्रय जनार्धन राउत – पेरू</li>
          <li>श्री खंडेराव भाऊसाहेब राउत – पेरू</li>
          <li>श्री अमरदीप भाऊसाहेब शेरकर – ऊस</li>
          <li>सौ. सुमनबाई सोपानराव गोर्डे – डाळिंब</li>
          <li>श्री प्रतीक्षा अमोल कोकणे – ऊस</li>
          <li>श्री किशोर श्रीकृष्ण शिंदे – आले</li>
          <li>श्री सोमनाथ भाऊसाहेब सरोदे – ऊस</li>
          <li>श्री संजय साळोबा सरोदे – डाळिंब</li>
          <li>श्री विजय माणिकचंद भंडारी – आंबा</li>
          <li>श्री नितीन गोरक्षनाथ भगत – बोर</li>
          <li>श्री विनोद शिवाजी वलटे – डाळिंब</li>
        </ul>
      </section>

    </div>
  );
};

export default BelpimpalgaonBhushan;
